import React from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";

export const MessageDisplay = () => {
  const myMessage = useSelector((state) => state.SelectedValues.messageHandler);
  const list = myMessage?.list;

  return (
    <div>
      {myMessage?.type === "error" && (
        <div
          style={{
            maxHeight: "100px",
            minHeight: "max-content",
            color: "red",
            backgroundColor: "#ffe7e6",
            padding: "5px",
            overflow: "auto",
            whiteSpace: "pre",
          }}
        >
          {myMessage?.message}
        </div>
      )}
      {myMessage?.type === "success" && (
        <div
          style={{
            maxHeight: "100px",
            minHeight: "20px",
            color: "white",
            backgroundColor: "green",
            padding: "5px",
            overflow: "auto",
            textAlign: "center",
          }}
        >
          {myMessage?.message}
        </div>
      )}
      {myMessage?.type === "validationError" && (
        <div
          style={{
            maxHeight: "100px",
            minHeight: "max-content",
            color: "red",
            padding: "5px",
            overflow: "auto",
            whiteSpace: "pre",
          }}
        >
          {myMessage?.message}
           {list && (
              <ul>
              {list.map((item, index) => (
                <li key={index} style={{ color: "#000000" }}>{item}
                </li>
              ))}
            </ul>
           )}
        </div>
      )}
    </div>
  );
};
